import React, { Component, Fragment } from 'react';
import FormInputNumber from '../../../_shared/forms/FormInputNumber';
import DatePicker from 'react-datepicker';
import FormError from '../../../_shared/forms/FormError';
import { SearchableSelect } from '../../../_shared/forms/FormMultiSelect';

export default class OperativeDetails extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <div className="row pb-3">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 cw-bg-grey text-white">Operative details</h6>
                    </div>
                </div>

                {/*<div className="row">*/}
                {/*    <div className="col-md-4">*/}
                {/*        <div className="form-group">*/}
                {/*            <label>Route started</label>*/}
                {/*            <DatePicker*/}
                {/*                className={this.props.errors.route_started ? "form-control is-invalid" : 'form-control'}*/}
                {/*                placeholderText="Route started"*/}
                {/*                selected={this.props.route_started || null}*/}
                {/*                onChange={date => this.props.handleDateChange(date, 'route_started')}*/}
                {/*                dateFormat="dd/MM/yyyy HH:mm"*/}
                {/*                timeFormat="HH:mm"*/}
                {/*                timeIntervals={1}*/}
                {/*                showTimeSelect*/}
                {/*            />*/}
                {/*            <FormError error={this.props.errors.route_started}/>*/}
                {/*        </div>*/}
                {/*    </div>*/}

                {/*    <div className="col-md-4">*/}
                {/*        <div className="form-group">*/}
                {/*            <label>Route arrived</label>*/}
                {/*            <DatePicker*/}
                {/*                className={this.props.errors.route_arrived ? "form-control is-invalid" : 'form-control'}*/}
                {/*                placeholderText="Route arrived"*/}
                {/*                selected={this.props.route_arrived || null}*/}
                {/*                onChange={date => this.props.handleDateChange(date, 'route_arrived')}*/}
                {/*                dateFormat="dd/MM/yyyy HH:mm"*/}
                {/*                timeFormat="HH:mm"*/}
                {/*                timeIntervals={1}*/}
                {/*                showTimeSelect*/}
                {/*            />*/}
                {/*            <FormError error={this.props.errors.route_arrived}/>*/}
                {/*        </div>*/}
                {/*    </div>*/}

                {/*    <div className="col-md-4">*/}
                {/*        <div className="form-group">*/}
                {/*            <label>Job completed</label>*/}
                {/*            <DatePicker*/}
                {/*                className={this.props.errors.job_completed ? "form-control is-invalid" : 'form-control'}*/}
                {/*                placeholderText="Job completed"*/}
                {/*                selected={this.props.job_completed || null}*/}
                {/*                onChange={date => this.props.handleDateChange(date, 'job_completed')}*/}
                {/*                dateFormat="dd/MM/yyyy HH:mm"*/}
                {/*                timeFormat="HH:mm"*/}
                {/*                timeIntervals={1}*/}
                {/*                showTimeSelect*/}
                {/*            />*/}
                {/*            <FormError error={this.props.errors.job_completed}/>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <SearchableSelect
                                label="first operative"
                                name="first_operative"
                                options={this.props.operatives}
                                handleChange={(e) => this.props.handleSearchableSelectChange(e, 'first_operative')}
                                value={this.props.first_operative}
                            />
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="form-group">
                            <SearchableSelect
                                label="second operative"
                                name="second_operative"
                                options={this.props.operatives}
                                handleChange={(e) => this.props.handleSearchableSelectChange(e, 'second_operative')}
                                value={this.props.second_operative}
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
